import classnames from 'classnames';
import React, { CSSProperties, FC, ReactNode } from 'react';
import { MediaType } from '../../../../../constants/MediaType';
import { isFile } from '../../../../../utils/media-manager-sdk/items';
import { FileThumbnail, FolderThumbnail } from '../../../../common';
import { IFileThumbnail, IOverlayedThumbnail } from '../../../../common/Thumbnails/types';
import styles from './SmartGridItemThumbnail.scss';

interface ISmartGridItemThumbnail {
  selected?: boolean;
  thumbnailBackground?: string;
  controls?: ReactNode;
  style?: CSSProperties;
}

export interface ISmartGridItemThumbnailOuter extends ISmartGridItemThumbnail, IFileThumbnail, IOverlayedThumbnail {}

const selectThumbnailWrapperClassName = (mediaType) => {
  switch (mediaType) {
    case MediaType.Picture:
    case MediaType.SecurePicture:
    case MediaType.Video:
    case MediaType.SecureVideo:
    case MediaType.VectorArt:
      return styles.thumbnailWithDarkOverlay;

    default:
      return '';
  }
};

export const SmartGridItemThumbnail: FC<ISmartGridItemThumbnailOuter> = ({
  file,
  width,
  height,
  className,
  thumbnailClassName,
  selected,
  style,
  thumbnailBackground,
  playVideoOnHover,
  videoNodeRef,
  params,
  isAlphaVideo,
  canvasNodeRef,
  isPlaying,
}) => (
  <div
    className={classnames(
      styles.thumbnailWrapper,
      selectThumbnailWrapperClassName(file.mediaType),
      { [styles.selected]: selected },
      className,
    )}
    data-hook="smart-grid-file-thumbnail"
  >
    {isFile(file) ? (
      <FileThumbnail
        className={classnames(styles.thumbnail, thumbnailClassName)}
        file={file}
        width={width}
        height={height}
        style={style}
        thumbnailBackground={thumbnailBackground}
        playVideoOnHover={playVideoOnHover}
        videoNodeRef={videoNodeRef}
        params={params}
        isAlphaVideo={isAlphaVideo}
        canvasNodeRef={canvasNodeRef}
        isPlaying={isPlaying}
      />
    ) : (
      <FolderThumbnail
        className={classnames(styles.thumbnail, thumbnailClassName)}
        folder={file}
        width={width}
        height={height}
      />
    )}
  </div>
);
